// extracted by css-extract-rspack-plugin
export default {"link":"_eccf08a5"};